/* shell: перевод строк интерфейса. Ключ — русская строка ровно как в коде. */
const d: Record<string, string> = {
  "Единица срока: часы, дни или недели.": "Period unit: hours, days or weeks.",
  "Категории: от 1 до 30, названия без повторов.": "Categories: 1 to 30, names must be unique.",
  "Напоминание: 2, 4, 8, 12 или 24 часа.": "Reminder: 2, 4, 8, 12 or 24 hours.",
  "По правилам при закрытии нужна заметка — напишите, чем закончился диалог.": "The rules require a note on close — write how the conversation ended.",
  "Срок автозакрытия — целое число от 1 до 365.": "Auto-close period: a whole number from 1 to 365.",
  "Такой категории нет в правилах диалогов.": "No such category in the conversation rules.",
  "Текст сообщения при закрытии — от 1 до 1000 знаков.": "Closing message text: 1 to 1000 characters.",
  "Ключ — латиница, цифры и «_»/«-», начинается с буквы.": "Key: Latin letters, digits, “_” or “-”, starting with a letter.",
  "Не больше 5 файлов.": "No more than 5 files.",
  "Неизвестная тема.": "Unknown topic.",
  "Такой ключ уже занят.": "This key is already taken.",
  "У шаблона нет ни текста, ни файлов.": "The snippet has neither text nor files.",
  "Шаблон не найден — возможно, его удалили.": "Snippet not found — it may have been deleted.",
  // шапка, хаб, меню
  "Дашборд": "Dashboard",
  "Входящие": "Inbox",
  "Контакты": "Contacts",
  "Отчёты": "Reports",
  "Настройки": "Settings",
  "Пользователь": "User",
  "Все разделы": "All sections",
  "Все разделы на одном экране": "All sections on one screen",
  "Рабочее пространство": "Workspace",
  "Выйти": "Sign out",
  "Выйти из аккаунта": "Sign out",
  "Меню приложения": "App menu",
  "Меню": "Menu",
  "Разделы приложения": "App sections",
  "Закрыть меню": "Close menu",
  "Найти раздел": "Find a section",
  "Ничего не нашлось": "Nothing found",
  "Ничего не нашлось — попробуйте другое слово.": "Nothing found — try another word.",
  "Всё рабочее пространство на одном экране — выберите раздел, он откроется целиком.": "Your whole workspace on one screen — pick a section and it opens full-size.",
  "Проверяем вход…": "Checking your session…",

  // каталог разделов
  "Рабочий экран": "Daily work",
  "Сводка и нагрузка": "Overview and workload",
  "Диалоги и папки": "Conversations and folders",
  "База клиентов": "Customer base",
  "Компании": "Companies",
  "Клиенты и их люди": "Companies and their people",
  "Диалоги": "Conversations",
  "Живой чат": "Live chat",
  "Каналы": "Channels",
  "Подключение номеров": "Connect numbers",
  "Каталог": "Catalog",
  "Провайдеры": "Providers",
  "Почта": "Email",
  "Ящики и письма": "Mailboxes and messages",
  "Виджеты": "Widgets",
  "Чат на сайте": "Website chat",
  "Клиенты и данные": "Customers and data",
  "Поля": "Fields",
  "Карточка клиента": "Customer card",
  "Этапы": "Stages",
  "Воронка продаж": "Sales funnel",
  "Теги": "Tags",
  "Темы диалогов": "Conversation topics",
  "Импорт": "Import",
  "Контакты из CSV": "Contacts from CSV",
  "Экспорт": "Export",
  "Выгрузка данных": "Data export",
  "CRM и Books → Hub": "CRM and Books → Hub",
  "Подсказки ответов": "Reply suggestions",
  "AI-агенты": "AI agents",
  "Автоответы 24/7": "Auto-replies 24/7",
  "Знания": "Knowledge",
  "Источники AI": "AI sources",
  "Промпты": "Prompts",
  "Правила текста": "Text rules",
  "Автоматизация": "Automation",
  "Процессы": "Workflows",
  "Триггеры и шаги": "Triggers and steps",
  "Рассылки": "Broadcasts",
  "Массовые отправки": "Bulk sends",
  "Шаблоны": "Snippets",
  "Быстрые ответы": "Quick replies",
  "Правила": "Rules",
  "Закрытие диалогов": "Closing conversations",
  "Настройки и отчёты": "Settings and reports",
  "Всё в одном окне": "All in one place",
  "Общие": "General",
  "Название и время": "Name and time",
  "Пользователи": "Users",
  "Сколько сейчас в разделе": "How many are in the section now",
  "Доступы": "Access",
  "Команды": "Teams",
  "Группы и роли": "Groups and roles",
  "Метрики и графики": "Metrics and charts",
  "Старт": "Getting started",
  "Первые шаги": "First steps",

  // роли и вход
  "Владелец": "Owner",
  "Администратор": "Admin",
  "Менеджер": "Manager",
  "Агент": "Agent",
  "Наблюдатель": "Viewer",
  "Почта {email} не добавлена в Hub. Попросите владельца или администратора добавить её в «Настройках пользователей».": "The email {email} has not been added to Hub. Ask the owner or an admin to add it in User settings.",
  "Вход через Google отменён.": "Google sign-in was cancelled.",
  "Вы долго были неактивны — по настройкам пространства нужно войти снова.": "You were inactive for a while — the workspace settings require you to sign in again.",
  "Доступ отозван. Обратитесь к владельцу или администратору.": "Access revoked. Contact the owner or an admin.",
  "Сессия входа устарела — нажмите «Войти через Google» ещё раз.": "The sign-in session has expired — click \"Sign in with Google\" again.",
  "Не удалось войти через Google ({code}). Попробуйте ещё раз.": "Could not sign in with Google ({code}). Please try again.",
  "Открываем Google…": "Opening Google…",
  "Войти через Google": "Sign in with Google",
  "Вход через Google ещё не настроен на сервере.": "Google sign-in is not configured on the server yet.",
  "Доступ только по приглашению: войти можно с той почтой Google, которую владелец или администратор добавил в «Настройках пользователей».": "Invite-only access: you can sign in with the Google account that the owner or an admin added in User settings.",
  "Локальная разработка: вход по почте без Google": "Local development: sign in by email without Google",
  "Войти": "Sign in",

  // тема
  "Включить светлую тему": "Switch to light theme",
  "Включить тёмную тему": "Switch to dark theme",
  "Светлая тема": "Light theme",
  "Тёмная тема": "Dark theme",

  // лендинг
  "Мария Соколова": "Maria Sokolova",
  "Здравствуйте! Нужен счёт на 12 позиций": "Hello! I need an invoice for 12 items",
  "2 мин": "2 min",
  "Игорь Дементьев": "Igor Dementiev",
  "Когда сможете отгрузить?": "When can you ship?",
  "14 мин": "14 min",
  "Ольга Смирнова": "Olga Smirnova",
  "Спасибо, всё получили!": "Thanks, we got everything!",
  "1 ч": "1 h",
  "Артём Лебедев": "Artem Lebedev",
  "Можно звонок на завтра?": "Can we have a call tomorrow?",
  "3 ч": "3 h",
  "Единые входящие": "Unified inbox",
  "Диалоги WhatsApp и Telegram в одной ленте.": "WhatsApp and Telegram conversations in one feed.",
  "Роли и доступ": "Roles and access",
  "Продавец, руководитель, администратор.": "Salesperson, manager, admin.",
  "Отвечают круглосуточно и передают людям.": "Reply around the clock and hand over to people.",
  "Одно сообщение сразу большой базе клиентов.": "One message to your whole customer base at once.",
  "Рабочие процессы": "Workflows",
  "Триггеры, назначения и задания без рутины.": "Triggers, assignments and tasks without the busywork.",
  "Отчёты и дашборд": "Reports and dashboard",
  "Нагрузка команды и время ответа.": "Team workload and response time.",
  "Возможности": "Features",
  "Роли": "Roles",
  "Доступ": "Access",
  "Вход": "Sign in",
  "Единый центр переписки": "One hub for every conversation",
  "Все диалоги клиентов —": "All customer conversations —",
  "в одном окне": "in one window",
  "{brand} собирает WhatsApp, Telegram и почту в общую ленту для отдела продаж: входящие, контакты, роли, AI-агенты, рассылки и отчёты. Войдите рабочей Google-почтой — и рабочий экран откроется сразу.": "{brand} brings WhatsApp, Telegram and email into one feed for your sales team: inbox, contacts, roles, AI agents, broadcasts and reports. Sign in with your work Google account and the workspace opens right away.",
  "Доступ по Google-аккаунту — только для добавленных почт": "Google sign-in — only for added email addresses",
  "канала": "channels",
  "экрана": "screens",
  "вход": "sign-in",
  "Все": "All",
  "Мои": "Mine",
  "Без ответа": "Awaiting reply",
  "{n} без ответа": "{n} awaiting reply",
  "диалогов": "conversation|conversations",
  "Среднее время 4 мин": "Avg. response 4 min",
  "Что внутри": "What's inside",
  "После входа открывается рабочий экран, а меню слева внизу переключает между всеми разделами приложения.": "After signing in you land on the workspace, and the menu at the bottom left switches between all sections of the app.",
  "Каждый видит своё": "Everyone sees their own",
  "Доступ к разделам зависит от роли. Администратор подключает каналы и приглашает коллег, руководитель видит все диалоги и отчёты, продавец работает только со своими клиентами.": "Access to sections depends on the role. Admins connect channels and invite colleagues, managers see all conversations and reports, salespeople work only with their own customers.",
  "Владелец / администратор": "Owner / admin",
  "Все разделы, приглашения, каналы, настройки и биллинг": "All sections, invitations, channels, settings and billing",
  "Полный доступ": "Full access",
  "Руководитель": "Manager",
  "Все диалоги, отчёты, переназначение и рабочие процессы": "All conversations, reports, reassignment and workflows",
  "Без настроек": "No settings",
  "Продавец": "Salesperson",
  "Только свои диалоги, контакты и шаблоны ответов": "Only their own conversations, contacts and snippets",
  "Свои клиенты": "Own customers",
  "Вход в рабочее пространство": "Sign in to the workspace",
  "Войдите рабочей Google-почтой": "Sign in with your work Google account",
  "Аккаунт Google подтверждает личность, а доступ к разделам выдаётся по вашей роли в команде. Пускаем только почты, которые владелец или администратор добавил в «Настройках пользователей».": "Your Google account confirms your identity, and access to sections is granted by your role in the team. Only email addresses added by the owner or an admin in User settings are allowed.",
  "Нет доступа? Попросите администратора вашей команды добавить почту.": "No access? Ask your team admin to add your email.",
  "единый центр переписки": "one hub for every conversation",
  "Данные хранятся в вашем рабочем пространстве": "Your data stays in your workspace",

  // каталог каналов (демо)
  "Раздел «{name}» в демо не открывается": "The \"{name}\" section does not open in the demo",
  "{name}: канал подключён — диалоги уже идут во «Входящие»": "{name}: channel connected — conversations are already flowing into Inbox",
  "{name}: канал отключён, история диалогов сохранена": "{name}: channel disconnected, conversation history kept",
  "настройки → каналы → каталог каналов": "settings → channels → channel catalog",
  "Подключено {n} из {total}": "Connected {n} of {total}",
  "Ключи и авторизации видит только администратор. Продавцы получают диалоги, а не пароли сервисов.": "Only admins see keys and authorizations. Salespeople get conversations, not service passwords.",
  "Каталог каналов": "Channel catalog",
  "Управляйте каналами и находите новые — чтобы отвечать клиентам там, где им удобно.": "Manage channels and discover new ones — to reply to customers wherever suits them.",
  "Демо-режим: подробная справка по каталогу каналов в макете недоступна": "Demo mode: detailed help on the channel catalog is not available in the mockup",
  "Узнать больше": "Learn more",
  "Категории каналов": "Channel categories",
  "Поиск по каталогу каналов": "Search the channel catalog",
  "Популярный": "Popular",
  "От": "By",
  "Подключено": "Connected",
  "Отключить {name}": "Disconnect {name}",
  "Подключить": "Connect",
  "Попробуйте другое название, провайдера или выберите «Все» — в каталоге {n} каналов.": "Try another name or provider, or choose \"All\" — the catalog has {n} channels.",
  "Сбросить фильтры": "Reset filters",
  "каналов": "channel|channels",
  "в подборке · подключено {n} из {total}": "in this selection · connected {n} of {total}",
  "Своего провайдера можно подключить по API": "You can connect your own provider via API",
  "Демо-режим: подключение имитируется в макете и не затрагивает реальные аккаунты провайдеров.": "Demo mode: connecting is simulated in the mockup and does not touch real provider accounts.",
  "Закрыть окно подключения": "Close the connection dialog",
  "Подключить {name}": "Connect {name}",
  "Провайдер: {provider}": "Provider: {provider}",
  "API-ключ": "API key",
  "Например, key_live_9f2c47ab81de": "For example, key_live_9f2c47ab81de",
  "Ключ выглядит корректно — можно подключать.": "The key looks valid — ready to connect.",
  "Ключ хранится в защищённом виде и доступен только администратору.": "The key is stored securely and is visible only to admins.",
  "Откроем окно авторизации {provider}. Hub запросит только доступ к сообщениям и имени профиля — публиковать ничего не сможем.": "We will open the {provider} authorization window. Hub will only request access to messages and your profile name — it cannot post anything.",
  "Код виджета": "Widget code",
  "Вставьте код перед закрывающим тегом </body> на всех страницах сайта.": "Paste the code before the closing </body> tag on every page of your site.",
  "Отмена": "Cancel",
  "Подключаем…": "Connecting…",
  "Подключить канал": "Connect channel",

  // моки каталога
  "Мессенджеры": "Messengers",
  "Звонки": "Calls",
  "Онлайн-чат": "Live chat",
  "Переписка из WhatsApp, Telegram, Viber, Instagram и Facebook попадает в единые входящие.": "Messages from WhatsApp, Telegram, Viber, Instagram and Facebook land in the unified inbox.",
  "Входящие и исходящие звонки с записью разговоров и карточкой клиента в ленте.": "Inbound and outbound calls with call recording and the customer card in the feed.",
  "Короткие уведомления и подтверждения, когда клиент не в мессенджере.": "Short notifications and confirmations when the customer is not on a messenger.",
  "Письма клиентов становятся диалогами с историей и вложениями.": "Customer emails become conversations with history and attachments.",
  "Виджет на сайте: клиент пишет в чат, продавец отвечает из Hub.": "Website widget: the customer writes in the chat, the salesperson replies from Hub.",
  "Telnyx (VoIP и SMS)": "Telnyx (VoIP and SMS)",
  "Подключите Telnyx, чтобы принимать звонки и отправлять SMS клиентам прямо из Hub.": "Connect Telnyx to take calls and send SMS to customers right from Hub.",
  "Виртуальные номера в 40 странах: звонки, запись разговоров и IVR-меню для отдела продаж.": "Virtual numbers in 40 countries: calls, call recording and IVR menus for the sales team.",
  "Облачная АТС: входящая линия, запись разговоров и карточка клиента в ленте диалогов.": "Cloud PBX: inbound line, call recording and the customer card in the conversation feed.",
  "Звонки WhatsApp": "WhatsApp calls",
  "Голосовые звонки через WhatsApp Business — тот же номер, что и для переписки.": "Voice calls via WhatsApp Business — the same number you use for messaging.",
  "Подключите WhatsApp Business API через Facebook, чтобы вести переписку без телефона и лимитов на устройства.": "Connect the WhatsApp Business API via Facebook to chat without a phone or device limits.",
  "Подключите Facebook Messenger и общайтесь с клиентами со страницы компании в Hub.": "Connect Facebook Messenger and talk to customers from your company page in Hub.",
  "Бот или аккаунт Telegram: диалоги приходят с ником клиента, историей и вложениями.": "Telegram bot or account: conversations arrive with the customer's handle, history and attachments.",
  "Личные сообщения и ответы на сторис прямо в общей ленте диалогов отдела продаж.": "Direct messages and story replies right in the sales team's shared conversation feed.",
  "Официальный аккаунт с рассылками и поддержкой клиентов — с именем отправителя вместо номера.": "Official account with broadcasts and customer support — a sender name instead of a number.",
  "Avito Сообщения": "Avito Messages",
  "Сообщения по объявлениям и заявки с Avito попадают в Hub рядом с WhatsApp и Telegram.": "Listing messages and enquiries from Avito land in Hub next to WhatsApp and Telegram.",
  "Массовые и сервисные SMS с подтверждением доставки и коротким именем отправителя.": "Bulk and transactional SMS with delivery confirmation and a short sender name.",
  "Отправка SMS по России: имя отправителя, отчёты о доставке и шаблоны уведомлений.": "SMS across Russia: sender name, delivery reports and notification templates.",
  "Ящик Google становится каналом: письма клиентов открываются как диалоги с историей.": "Your Google mailbox becomes a channel: customer emails open as conversations with history.",
  "Своя почта (IMAP / SMTP)": "Your own email (IMAP / SMTP)",
  "Яндекс, Mail.ru или собственный сервер: подключите по адресу, логину и паролю приложения.": "Yandex, Mail.ru or your own server: connect with the address, login and app password.",
  "Корпоративная почта Outlook с календарём встреч и вложениями в карточке клиента.": "Corporate Outlook email with a meeting calendar and attachments in the customer card.",
  "Чат Hub на сайте": "Hub chat on your website",
  "Виджет с WhatsApp, Telegram и почтой: клиент выбирает канал, чат идёт во входящие.": "A widget with WhatsApp, Telegram and email: the customer picks a channel, the chat goes to the inbox.",
  "Подключите Jivo, чтобы переписка с сайта шла в Hub вместе с остальными каналами.": "Connect Jivo so website chats flow into Hub alongside the other channels.",
  "Мультиязычный чат для сайта: история, файлы и передача диалога продавцу в один клик.": "Multilingual website chat: history, files and one-click handover to a salesperson.",
  "Авторизация в сервисе": "Authorize with the service",
  "Откроем окно авторизации. Hub запросит только доступ к сообщениям и имени профиля — публиковать ничего не сможем.": "We will open an authorization window. Hub will only request access to messages and your profile name — it cannot post anything.",
  "Подключение по ключу": "Connect with a key",
  "Скопируйте ключ в кабинете провайдера. Hub хранит его в защищённом виде и показывает только администратору.": "Copy the key from the provider's dashboard. Hub stores it securely and shows it only to admins.",
  "Код для сайта": "Code for your website",
  "Вставьте код виджета перед закрывающим тегом </body> — и чат появится на всех страницах сайта.": "Paste the widget code before the closing </body> tag — and the chat appears on every page of your site.",

  // палитра ⌘K
  "Введите команду или выполните поиск.": "Type a command or search.",
  "Поиск по рабочему пространству": "Search the workspace",
  "Очистить поиск": "Clear search",
  "Результаты поиска": "Search results",
  "Ничего не найдено": "Nothing found",
  "Попробуйте другое слово — например, «Входящие», «Настройки» или имя клиента.": "Try another word — for example \"Inbox\", \"Settings\" or a customer's name.",
  "навигация": "navigate",
  "открыть": "open",
  "закрыть": "close",
  "поиск по всему пространству": "search across the workspace",
  "Поиск бесед по имени": "Search conversations by name",
  "Фильтрация разговоров по областям": "Filter conversations by area",
  "беседа": "conversation",
  "диалог клиент чат поиск имя": "conversation customer chat search name",
  "фильтр диалог область канал этап": "filter conversation area channel stage",
  "настройки": "settings",
  "{text} настройки рабочего пространства": "{text} workspace settings",
  "Беседы": "Conversations",
  "Страницы": "Pages",
  "Люди": "People",
  "Замечания": "Feedback",
  "контакт": "contact",
  "команда": "team",
  "№{id} {title}": "#{id} {title}",
  "идея": "idea",
  "проблема": "issue",
  "Ввод в должность": "Onboarding",
  "онбординг новичок начало работы чеклист первый шаг": "onboarding newcomer getting started checklist first step",
  "Панель управления": "Dashboard",
  "дашборд dashboard показатели обзор": "dashboard metrics overview",
  "inbox диалоги чаты переписка беседы": "inbox conversations chats messages",
  "клиенты база контактов телефон почта": "customers contact base phone email",
  "Агенты искусственного интеллекта": "AI agents",
  "ai агенты боты искусственный интеллект автоматизация": "ai agents bots artificial intelligence automation",
  "Трансляции": "Broadcasts",
  "рассылки трансляции broadcasts сообщения клиентам": "broadcasts campaigns messages to customers",
  "workflow автоматизация сценарии процессы": "workflow automation scenarios processes",
  "Отчеты": "Reports",
  "отчеты аналитика статистика цифры": "reports analytics statistics numbers",
  "Настройки рабочего пространства": "Workspace settings",
  "настройки settings рабочее пространство": "settings workspace",
  "каналы whatsapp telegram подключение": "channels whatsapp telegram connect",
  "каталог провайдеры sms телефония почта": "catalog providers sms telephony email",
  "ии ассистент подсказки ответы": "ai assistant suggestions replies",
  "Источники знаний AI": "AI knowledge sources",
  "база знаний документы статьи источники": "knowledge base documents articles sources",
  "промпты правила тон текста перевод": "prompts rules tone of voice translation",
  "Поля контактов": "Contact fields",
  "поля карточка клиента атрибуты": "fields customer card attributes",
  "Жизненный цикл": "Lifecycle",
  "этапы воронка сделки лиды": "stages funnel deals leads",
  "автозакрытие категории тональность": "auto-close categories sentiment",
  "Шаблоны ответов": "Snippets",
  "шаблоны сниппеты быстрые ответы": "templates snippets quick replies",
  "теги метки категории диалогов": "tags labels conversation categories",
  "Виджеты для сайта": "Website widgets",
  "виджеты сайт кнопка чат": "widgets website button chat",
  "Подключение почты": "Email setup",
  "почта gmail ящик imap": "email gmail mailbox imap",
  "Импорт контактов": "Import contacts",
  "импорт csv загрузка базы": "import csv upload base",
  "Экспорт данных": "Data export",
  "экспорт выгрузка csv данные": "export download csv data",
  "Настройки пользователей": "User settings",
  "пользователи доступы приглашение роли": "users access invitation roles",
  "Настройки команды": "Team settings",
  "команды сотрудники группы": "teams employees groups",
  "Общие сведения": "General",
  "тайм-аут дайджест часовой пояс": "timeout digest time zone",
  "Живой макет переписки": "Live chat mockup",
  "диалоги макет чат переписка": "conversations mockup chat messaging",
  "Начать новую беседу": "Start a new conversation",
  "создать беседа диалог новый": "create conversation new",
  "Создать рассылку": "Create a broadcast",
  "создать рассылка трансляция": "create broadcast campaign",
  "Пригласить пользователя": "Invite a user",
  "пригласить сотрудник доступ": "invite employee access",
  "Добавить канал": "Add a channel",
  "подключить канал номер": "connect channel number",

  // ошибки API
  "Нет связи с сервером. Проверьте интернет и попробуйте ещё раз.": "No connection to the server. Check your internet and try again.",
  "Ошибка {status}: {message}": "Error {status}: {message}",
  "Сессия закончилась — войдите снова.": "Your session has ended — sign in again.",
  "Вы долго были неактивны — войдите снова.": "You were inactive for a while — sign in again.",
  "Проверьте название: от 1 до 60 символов.": "Check the name: 1 to 60 characters.",
  "Адрес: только строчные латинские буквы, цифры и дефис — от 3 до 40 символов.": "Address: lowercase Latin letters, digits and hyphens only — 3 to 40 characters.",
  "Неизвестный часовой пояс.": "Unknown time zone.",
  "Тайм-аут — от 1 до 120 минут.": "Timeout must be between 1 and 120 minutes.",
  "Сайт должен начинаться с https://": "The website must start with https://",
  "Такой язык пока не поддерживается.": "This language is not supported yet.",
  "Слишком длинный текст.": "The text is too long.",
  "Пользователь не найден или отключён.": "User not found or disabled.",
  "Такое название уже есть — выберите другое.": "This name is already taken — choose another.",
  "Команды меняют владелец, администраторы и менеджеры.": "Teams can be changed by the owner, admins and managers.",
  "Неизвестная частота писем.": "Unknown email frequency.",
  "Время — в формате ЧЧ:ММ.": "Time must be in HH:MM format.",
  "Не найдено — возможно, уже удалено.": "Not found — it may have already been deleted.",
  "Телефон в неверном формате — укажите код страны, например +971 50 123 4567.": "Invalid phone format — include the country code, e.g. +971 50 123 4567.",
  "Контакт с таким телефоном уже есть.": "A contact with this phone number already exists.",
  "Контакт с такой почтой уже есть.": "A contact with this email already exists.",
  "Укажите имя, телефон или почту.": "Enter a name, phone or email.",
  "Агент может назначить ответственным только себя.": "An agent can only assign themselves.",
  "Действие доступно владельцу, администраторам и менеджерам.": "This action is available to the owner, admins and managers.",
  "Этап не найден — обновите страницу.": "Stage not found — refresh the page.",
  "Тег не найден — обновите страницу.": "Tag not found — refresh the page.",
  "Команда не найдена — обновите страницу.": "Team not found — refresh the page.",
  "В числовом поле должно быть число.": "A numeric field must contain a number.",
  "Неизвестная папка.": "Unknown folder.",
  "Неизвестное действие.": "Unknown action.",
  "Этап по умолчанию удалить нельзя — сначала назначьте другой этап по умолчанию.": "The default stage cannot be deleted — set another stage as default first.",
  "Этап по умолчанию не может быть в группе «потерянные».": "The default stage cannot be in the \"lost\" group.",
  "Встроенное поле удалить нельзя — его можно только скрыть.": "A built-in field cannot be deleted — it can only be hidden.",
  "Поле с таким ключом уже есть.": "A field with this key already exists.",
  "Ключ поля — латиница, цифры и _, начинается с буквы.": "Field key: Latin letters, digits and _, starting with a letter.",
  "Этот тип поля выбрать нельзя: у встроенного поля тип не меняется.": "This field type cannot be chosen: a built-in field's type cannot change.",
  "Неизвестный цвет.": "Unknown colour.",
  "Неизвестный режим показа поля.": "Unknown field visibility mode.",
  "Файл больше 100 МБ.": "The file is larger than 100 MB.",
  "По почте Gmail принимает вложения до 25 МБ — отправьте ссылкой или сожмите.": "Gmail accepts attachments up to 25 MB — send a link or compress it.",
  "Google не дал отправить письмо из этого ящика: в делегировании домена нужно право gmail.send.": "Google refused to send from this mailbox: the domain delegation needs the gmail.send scope.",
  "В файле больше 200 000 строк.": "The file has more than 200,000 rows.",
  "Не удалось прочитать файл: сохраните его в UTF-8 или Windows-1251.": "Could not read the file: save it as UTF-8 or Windows-1251.",
  "Файл пустой.": "The file is empty.",
  "В первой строке файла нет заголовков колонок.": "The first row of the file has no column headers.",
  "Сопоставление колонок не прочиталось — начните заново.": "The column mapping could not be read — start over.",
  "Сопоставьте хотя бы одну колонку с именем, телефоном или почтой.": "Map at least one column to name, phone or email.",
  "Одно и то же поле выбрано для двух колонок — оставьте по одной колонке на поле.": "The same field is selected for two columns — keep one column per field.",
  "Новые поля карточки может создавать только администратор — выберите для этих колонок «Не импортировать».": "Only an admin can create new card fields — choose \"Do not import\" for these columns.",
  "Выгрузка доступна владельцу, администраторам и сотрудникам с правом «Экспорт данных».": "Export is available to the owner, admins and staff with the \"Data export\" permission.",
  "Эта выгрузка появится вместе с подключением каналов (этап 3).": "This export will become available together with channel connections (stage 3).",
  "В файле есть колонки с одинаковыми заголовками — переименуйте их.": "The file has columns with identical headers — rename them.",
  "Предыдущая выгрузка ещё собирается — дождитесь её.": "The previous export is still being prepared — please wait for it.",
  "Ссылка на файл истекла — запросите выгрузку заново.": "The file link has expired — request the export again.",
  "Доступ отозван. Обратитесь к администратору.": "Access revoked. Contact an admin.",
  "Пользователь с такой почтой уже есть.": "A user with this email already exists.",
  "Проверьте почту — адрес выглядит неверно.": "Check the email — the address looks invalid.",
  "Эту роль вы назначить не можете.": "You cannot assign this role.",
  "Недостаточно прав для этого действия.": "You do not have permission for this action.",
  "Управлять участниками могут владелец, администраторы и менеджеры с правом «Управление участниками».": "Members can be managed by the owner, admins and managers with the \"Manage members\" permission.",
  "Раздел доступен владельцу и администраторам.": "This section is available to the owner and admins.",
  "Глазами владельца смотреть нельзя.": "You cannot view Hub as the owner.",
  "У роли «Наблюдатель» только просмотр — изменить это может администратор.": "The \"Viewer\" role is read-only — an admin can change this.",
  "Нельзя отозвать доступ у самого себя.": "You cannot revoke your own access.",
  "Напишите, что осталось не так, — без комментария вернуть в работу нельзя.": "Describe what is still wrong — it cannot be reopened without a comment.",
  "Замечание уже в очереди робота.": "This feedback is already in the bot's queue.",
  "Скриншот не подошёл: нужен PNG, JPG или WebP до 6 МБ.": "The screenshot was rejected: use PNG, JPG or WebP up to 6 MB.",
  "Подключать каналы могут владелец, администраторы и сотрудники с правом «Каналы».": "Channels can be connected by the owner, admins and staff with the \"Channels\" permission.",
  "Шлюз WhatsApp не настроен на сервере (WA_GATEWAY_TOKEN).": "The WhatsApp gateway is not configured on the server (WA_GATEWAY_TOKEN).",
  "Шлюз WhatsApp не отвечает — попробуйте через минуту.": "The WhatsApp gateway is not responding — try again in a minute.",
  "Шлюз WhatsApp вернул ошибку.": "The WhatsApp gateway returned an error.",
  "Номер не подключён — переподключите канал в разделе «Каналы».": "The number is not connected — reconnect the channel in Channels.",
  "Канал WhatsApp не подключён — переподключите его в разделе «Каналы».": "The WhatsApp channel is not connected — reconnect it in Channels.",
  "Канал этого диалога удалён — ответить нельзя.": "This conversation's channel has been deleted — you cannot reply.",
  "Слишком много новых диалогов за час — подождите, чтобы WhatsApp не заблокировал номер.": "Too many new conversations this hour — wait so WhatsApp does not block the number.",
  "Файл не найден на сервере.": "File not found on the server.",
  "Сообщение пустое.": "The message is empty.",
  "Неизвестный статус диалога.": "Unknown conversation status.",
  "Канал не найден — обновите страницу.": "Channel not found — refresh the page.",
  "Этот канал уже привязан к номеру.": "This channel is already linked to a number.",
  "Такой тип канала пока не поддерживается.": "This channel type is not supported yet.",
  "Это архивный канал: сессии WhatsApp у него нет.": "This is an archive channel: it has no WhatsApp session.",
  "Telegram — это телефон с кодом страны (+971…) или ник вида @name.": "Telegram is a phone number with country code (+971…) or a handle like @name.",
  // шапка: режим «глазами сотрудника»
  "Вы смотрите Hub глазами сотрудника {name} ({role}): разделы, клиенты и переписка — как видит он": "You are viewing Hub as {name} ({role}): sections, customers and conversations exactly as they see them",
  "Вернуться к себе ({name})": "Back to myself ({name})",
};
export default d;
